import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'kiene-gewicht-eingeben-numberpad-dialog',
    templateUrl: './gewicht-eingeben-numberpad-dialog.component.html',
    styleUrls: ['./gewicht-eingeben-numberpad-dialog.component.scss'],
})
export class GewichtEingebenNumberpadDialogComponent implements OnInit {
    private readonly maxLength = 10;
    gewichtString = '';

    constructor(
        public dialogRef: MatDialogRef<GewichtEingebenNumberpadDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
    ) {}

    ngOnInit(): void {
        const initialGewicht = this.data?.gewicht;
        if (initialGewicht !== null && initialGewicht !== undefined && !Number.isNaN(Number(initialGewicht))) {
            this.gewichtString = Number(initialGewicht).toString().replace('.', ',');
        }
    }

    @HostListener('window:keydown', ['$event'])
    catchKeyboardDownEvent(event: KeyboardEvent) {
        if (event.code === 'Enter' || event.code === 'NumpadEnter') {
            // Prevent focused keypad button from receiving Enter as click.
            event.preventDefault();
            event.stopPropagation();
            this.save();
        }
    }

    @HostListener('window:keyup', ['$event'])
    catchKeyboardEvent(event: KeyboardEvent) {
        console.log(event.code);
        if (event.code === 'Enter' || event.code === 'NumpadEnter') {
            return;
        }

        const numericMatch = event.code.match(/^(Numpad|Digit)(\d)$/);
        if (numericMatch?.[2]) {
            this.addNumber(Number.parseInt(numericMatch[2], 10));
            return;
        }

        if (event.code.startsWith('Numpad') || event.code.startsWith('Digit')) {
            const splitted = event.code.split(/Numpad|Digit/);
            if (splitted && splitted[1]) {
                const parsed = Number.parseInt(splitted[1], 10);
                if (!Number.isNaN(parsed)) {
                    this.addNumber(parsed);
                }
            }
        } else if (event.code === 'Backspace') {
            this.backspace();
        }
    }

    addNumber(value: number) {
        if (!Number.isInteger(value) || value < 0 || value > 9 || this.gewichtString.length >= this.maxLength) {
            return;
        }
        this.gewichtString += value.toString();
    }

    comma() {
        if (this.gewichtString.includes(',') || this.gewichtString.length >= this.maxLength) {
            return;
        }
        this.gewichtString += ',';
    }

    backspace() {
        this.gewichtString = this.gewichtString.substring(0, this.gewichtString.length - 1);
    }

    close() {
        this.dialogRef.close();
    }

    save() {
        const numberStr = this.gewichtString.replace(',', '.');
        const weight = Number.parseFloat(numberStr);
        this.dialogRef.close(weight);
    }
}
